var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSatisfaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.451,
    height: 63,
    viewBox: "0 0 48.451 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dfeef7;}.b{fill:#f9f7f6;}.b,.c,.d{stroke:#1f3951;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{fill:none;}.d{fill:#fd9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-862.881 -97.506)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M886.091,146.051c-2.32,0-4-3.832-6.1-4.513-2.169-.7-5.781,1.382-7.587.068-1.823-1.327-.948-5.414-2.275-7.238-1.314-1.8-5.48-2.228-6.184-4.4-.68-2.093,2.419-4.874,2.419-7.193s-3.1-5.1-2.419-7.194c.7-2.168,4.87-2.592,6.184-4.4,1.327-1.822.452-5.911,2.276-7.238,1.805-1.314,5.417.773,7.587.068,2.093-.679,3.778-4.512,6.1-4.512s4,3.832,6.1,4.512c2.169.7,5.781-1.382,7.586-.067,1.824,1.327.948,5.414,2.275,7.238,1.314,1.8,5.48,2.228,6.185,4.4.68,2.093-2.42,4.874-2.42,7.193s3.1,5.1,2.42,7.193c-.7,2.169-4.871,2.593-6.185,4.4-1.327,1.823-.452,5.912-2.276,7.239-1.805,1.314-5.417-.773-7.587-.068C890.095,142.219,888.41,146.051,886.091,146.051Z",
    transform: "translate(3 -2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 13.611,
    cy: 13.627,
    rx: 13.611,
    ry: 13.627,
    transform: "translate(872.48 109.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M886.091,146.051c-2.32,0-4-3.832-6.1-4.513-2.169-.7-5.781,1.382-7.587.068-1.823-1.327-.948-5.414-2.275-7.238-1.314-1.8-5.48-2.228-6.184-4.4-.68-2.093,2.419-4.874,2.419-7.193s-3.1-5.1-2.419-7.194c.7-2.168,4.87-2.592,6.184-4.4,1.327-1.822.452-5.911,2.276-7.238,1.805-1.314,5.417.773,7.587.068,2.093-.679,3.778-4.512,6.1-4.512s4,3.832,6.1,4.512c2.169.7,5.781-1.382,7.586-.067,1.824,1.327.948,5.414,2.275,7.238,1.314,1.8,5.48,2.228,6.185,4.4.68,2.093-2.42,4.874-2.42,7.193s3.1,5.1,2.42,7.193c-.7,2.169-4.871,2.593-6.185,4.4-1.327,1.823-.452,5.912-2.276,7.239-1.805,1.314-5.417-.773-7.587-.068C890.095,142.219,888.41,146.051,886.091,146.051Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M888,128.692l4.395,2.31-.839-4.894,3.556-3.466-4.914-.714-2.2-4.452-2.2,4.452-4.914.714,3.556,3.466L883.6,131Z",
    transform: "translate(-1.907 -2.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M897.317,150.589l3.461,14.631H873.557l3.461-14.631",
    transform: "translate(-1.077 -5.714)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y1: 7.166,
    x2: 0.986,
    transform: "translate(880.067 148.045)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 0.986,
    y2: 7.166,
    transform: "translate(891.128 148.045)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatisfaction);
export default __webpack_public_path__ + "static/media/satisfaction.a4b315972d0c5333634584607e9e1599.svg";
export { ForwardRef as ReactComponent };